export enum CancellationTypes {
  full,
  partial,
  all,
}
